module.exports = __webpack_public_path__ + "img/expandis.0ceb70fb.png";